export const ContentFormUtils = require("./ContentFormUtils").default

export const ContentMethodFormWrapper =
  require("./ContentMethodFormWrapper").default

export const ContentMethodRichText =
  require("./richtext/ContentMethodRichText").default

export const ContentMethodEmbed = require("./embed/ContentMethodEmbed").default
export const ContentMethodEmbedCode =
  require("./embed/ContentMethodEmbedCode").default
export const ContentMethodEmbedLink =
  require("./embed/ContentMethodEmbedLink").default

export const ContentMethodSubmit =
  require("./submit/ContentMethodSubmit").default
export const ContentMethodFileType =
  require("./submit/ContentMethodFileType").default

export const ContentMethodUpload =
  require("./upload/ContentMethodUpload").default
